import React from 'react';

import './MaintenanceBanner.css';
import { BannerSeverity } from '../../models/banner/BannerObject';

const SEVERITY_ICONS: Record<BannerSeverity, string> = {
  INFO: 'ℹ',
  WARNING: '⚠',
  CRITICAL: '⛔',
};

interface BannerContentProps {
  title?: string | null;
  message: string;
  severity: BannerSeverity;
}

function BannerContent({ title, message, severity }: Readonly<BannerContentProps>): React.ReactElement {
  const paragraphs = message.split(/\n{2,}/).filter(Boolean);

  return (
    <div className={`maintenance-banner maintenance-banner-${severity.toLowerCase()}`}>
      <span className="maintenance-banner-icon">{SEVERITY_ICONS[severity]}</span>
      <span className="maintenance-banner-message">
        {title && <span className="maintenance-banner-title">{title}</span>}
        {paragraphs.map((paragraph) => (
          <span key={paragraph} className="maintenance-banner-paragraph">{paragraph}</span>
        ))}
      </span>
    </div>
  );
}

export default BannerContent;
